import {Component, Output, EventEmitter} from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'kyt-login',
  template: `
    <mat-card>
      <mat-card-title>
        <img src="../../../../assets/images/total-energies-logo.svg" alt="total-energies-logo"/>
      </mat-card-title>
      <mat-card-content>
        <div>
          <h5>KYT</h5>
          <div class="btn-container">
          <button mat-flat-button (click)="connexionRequest()">
            <mat-icon>arrow_right</mat-icon>
            Connexion
          </button>
          <button mat-flat-button (click)="externalLogin()">
            <mat-icon>arrow_right</mat-icon>
            External Login
          </button>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  `,
  styleUrls: ['./login.container.scss']
})
export class LoginContainer{
  @Output() connexionRequested: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private router: Router,private spinnerSerivce: NgxSpinnerService){ }

  connexionRequest(): void {
    this.connexionRequested.emit(true);
  }

  externalLogin(): void {
    
  }

}
